import React from 'react';

import { LanguageSwitcher } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  MenuFooter,
  MenuSocial,
} from '../../implementations';

import { ReactComponent as FooterLeft } from '../../assets/images/footer-left.svg';
import { ReactComponent as FooterRight } from '../../assets/images/footer-right.svg';

import './style.scss';

const Footer = ({ entity }) => {
  return (
    <footer className="Footer">
      <div className="Footer__menu">
        <MenuFooter />

        <div className="Footer__menu__overlay">
          <FooterLeft />
          <FooterRight />
        </div>
      </div>

      <div className="Footer__bottom">
        <Container>
          <div className="row">
            <div className="col-12 Footer__bottom__container">
              <LanguageSwitcher hideActive={false} />
              <MenuSocial inverse />
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
